import React, { useState ,useEffect} from "react";
import { Link } from 'react-router-dom'
import { Sidebar, Menu,SubMenu , MenuItem } from 'react-pro-sidebar';
import * as Icon from "react-bootstrap-icons";
import { useParams } from 'react-router-dom';
const SidebarMenu = () => {
  
var cate ="category";
var subcategory ="subcategory";
var division ="division";
 
  const[logged,setLogged] = useState(false)
  const[Tokens,setTokens] = useState('')
  const[URLNAME,setURLNAME] = useState('')
  const timeNow = Math.floor(Date.now()/1000)
  useEffect(()=>{
    const getdata = JSON.parse(localStorage.getItem('Hrtech_token'))
    const URL = window.location.pathname;
    const paths = URL.split("/");
  const currentpath = paths[1];
 
    if(getdata){
      const tokenVal = JSON.parse(atob(getdata.split('.')[1]));
      console.log("nnnvvv",tokenVal)
      if(tokenVal.exp>timeNow){
        setLogged(true)
        setTokens(tokenVal)
      }else{
        setLogged(false)
        localStorage.clear();
        // history.push('/')
      }
    }
    else{
      setLogged(false)
      // history.push('/')
    }
  
  },[])

  const CheckUrl =(e)=>{
    console.log("eeeee",e)
    setURLNAME(e)
  }
  
  const [menuCollapse, setMenuCollapse] = useState(false)
  return (
    <>
    <div className='main-sidebar'>
    <div className="logomain"><img src="https://www.hrtech.sg/assets/img/logo.png" /></div>

      <Sidebar backgroundColor="rgb(255, 237, 237)">
   
  <Menu>
    <MenuItem  routerLink={<Link to="/dashboard" />} icon={<Icon.Grid />}> Dashboard</MenuItem>
  {Tokens.Role == "Admin" ? <><MenuItem  routerLink={<Link to="/users" />} icon={<Icon.Person />}> Users</MenuItem></> :null}  
    <SubMenu label="Header" icon={<Icon.MenuButtonWide />}>
    <MenuItem  routerLink={<Link to="/navbar" />}> Navbar</MenuItem>
    <MenuItem routerLink={<Link to="/banner" />}> Banner</MenuItem>
    </SubMenu>
    <Menu>
    <SubMenu label="category Section" icon={<Icon.JournalText />}>
    <MenuItem active={URLNAME =="category" ? true:false} onClick={()=>CheckUrl(cate)} icon={<Icon.Stars />} routerLink={<Link to="/category" />}> Category</MenuItem>
    <MenuItem active={URLNAME =="subcategory" ? true:false}icon={<Icon.Stars />} onClick={()=>CheckUrl(subcategory)} routerLink={<Link to="/subcategory" />}> Subcategory</MenuItem>
    <MenuItem active={URLNAME =="division" ? true:false} icon={<Icon.Stars />} onClick={()=>CheckUrl(division)} routerLink={<Link to="/division" />}> Division</MenuItem>
    </SubMenu>
  </Menu>
    <Menu>
    <SubMenu label="Jobs Section" icon={<Icon.Search />}>
    <MenuItem routerLink={<Link to="/company" />}> company</MenuItem>
    <MenuItem routerLink={<Link to="/jobs" />}> jobs</MenuItem>
    <MenuItem routerLink={<Link to="/jobsapplied" />}> jobs Applied</MenuItem>
    </SubMenu>
  </Menu>
    <Menu>
    <SubMenu label="Marketplace " icon={<Icon.BarChart />}>
    <MenuItem routerLink={<Link to="/marketplace" />}> Marketplace</MenuItem>
    <MenuItem routerLink={<Link to="/marketplacereview" />}> Reviews</MenuItem>
    <MenuItem routerLink={<Link to="/brochurelist" />}> Brochure list</MenuItem>
    </SubMenu>
  </Menu>
    <Menu>
    <SubMenu label="About us " icon={<Icon.People />}>
    <MenuItem routerLink={<Link to="/abouts" />}> Abouts</MenuItem>
    <MenuItem routerLink={<Link to="/advisoryboards" />}> Advisory boards</MenuItem>
    <MenuItem routerLink={<Link to="/clients" />}> Clients</MenuItem>
    <MenuItem routerLink={<Link to="/investors" />}> Investors</MenuItem>
    </SubMenu>
  </Menu>
	    <Menu>
    <SubMenu label="Certification " icon={<Icon.People />}>
    <MenuItem routerLink={<Link to="/certification" />}> Certification</MenuItem>
    <MenuItem routerLink={<Link to="/certification-bottom" />}> Certification bottom</MenuItem>
     
    </SubMenu>
  </Menu>
  <MenuItem icon={<Icon.PencilSquare />} routerLink={<Link to="/blog" />}> Blogs</MenuItem>
	 <MenuItem icon={<Icon.Newspaper />} routerLink={<Link to="/articles" />}> Articles</MenuItem>
<MenuItem icon={<Icon.Newspaper />} routerLink={<Link to="/hrglossary" />}> Hr Glossary</MenuItem>
  <MenuItem icon={<Icon.CardHeading />} routerLink={<Link to="/techtalks" />}> Tech Talks</MenuItem>
  <MenuItem icon={<Icon.PersonGear />} routerLink={<Link to="/resources" />}> Resources</MenuItem>
  <MenuItem icon={<Icon.PersonVcard />} routerLink={<Link to="/certification-enquiry" />}> Certification Enquies</MenuItem>  
<MenuItem icon={<Icon.ArrowDownCircle />} routerLink={<Link to="/resourcedownloadlist" />}> Resources download</MenuItem>
  <MenuItem icon={<Icon.CalendarDay />} routerLink={<Link to="/events" />}> Events</MenuItem>
  <MenuItem icon={<Icon.Newspaper />} routerLink={<Link to="/news" />}> News</MenuItem>
  <MenuItem icon={<Icon.PersonVcard />} routerLink={<Link to="/enquiry" />}> Enquiry</MenuItem>
  <MenuItem icon={<Icon.PersonLinesFill />} routerLink={<Link to="/contact" />}> Contact</MenuItem>
  <MenuItem icon={<Icon.Subtract />} routerLink={<Link to="/subscribe" />}> Subscribe</MenuItem>
  </Menu>
</Sidebar>;
{/* 
        <Link to="/" className='text-light'>Blogs</Link><br></br>
        <Link to="/category" className='text-light'>Category</Link><br></br>
        <Link to="/subcategory" className='text-light'>Subcategory</Link><br></br>
        <Link to="/division" className='text-light'>Division</Link><br></br>
        <Link to="/marketplace" className='text-light'>MarketPlace</Link><br></br>
        <Link to="/techtalks" className='text-light'>TechTalks</Link><br></br>
        <Link to="/resources" className='text-light'>Resources</Link><br></br>
        <Link to="/events" className='text-light'>Events</Link><br></br>
        <Link to="/news" className='text-light'>News</Link><br></br>
        <Link to="/company" className='text-light'>Company</Link><br></br>
        <Link to="/jobs" className='text-light'>jobs</Link><br></br>
        <Link to="/jobsapplied" className='text-light'>jobs Applied</Link><br></br>
        <Link to="/navbar" className='text-light'>Navbar</Link><br></br>
        <Link to="/abouts" className='text-light'>Abouts</Link><br></br>
        <Link to="/banner" className='text-light'>Banner</Link><br></br>
        <Link to="/marketplacereview" className='text-light'>Review</Link><br></br>
        <Link to="/brochurelist" className='text-light'>Brochure List</Link><br></br>
        <Link to="/resourcedownloadlist" className='text-light'>Resource download list</Link><br></br>
        <Link to="/enquiry" className='text-light'>Enquiry</Link><br></br>
        <Link to="/contact" className='text-light'>Contact</Link><br></br>
        <Link to="/subscribe" className='text-light'>Subscribe</Link><br></br>
        <Link to="/investors" className='text-light'>Investors</Link><br></br>
        <Link to="/advisoryboards" className='text-light'>Advisory boards</Link><br></br> */}
    </div></>
  )
}

export default SidebarMenu
